import React, { useState } from 'react'
import { Link, useLocation, useSearchParams } from 'react-router-dom'
import { Button, Modal } from 'components'

import { Edit, Trash } from 'iconsax-react'

import styles from './styles.module.css'
import useColors from 'utils/Colors'

import { DeleteAddress } from 'services/account'
import { toast } from 'react-toastify'
import { _queryToUrlParams } from 'utils/_helpers'

const AddressActionModal = ({ isOpen, setIsOpen, data }) => {
  const [step, setStep] = useState(0)
  const [loading, setLoading] = useState(false)

  const [searchParams, setSearchParams] = useSearchParams()

  const location = useLocation()
  const Colors = useColors()

  const deleteAddress = () => {
    setLoading(true)
    DeleteAddress(data.id)
      .then((result) => {
        setLoading(false)
        toast.success('آدرس با موفقیت حذف شد')
        setIsOpen({ show: false, data: undefined, refetch: true })
      })
      .catch((err) => setLoading(true))
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={(show) => setIsOpen({ show, data: undefined })}
    >
      <div className={styles.content}>
        <h6 className={styles.title}>
          {step == 0 ? data?.address_name : 'آیا از حذف این آدرس مطمئن هستید؟'}
        </h6>
        {step == 0 && <p className={styles.desc}>{data?.address}</p>}
        {step == 0 ? (
          <>
            <div style={{ marginBottom: 10 }}>
              <Button type={'danger'} onClick={() => setStep(1)}>
                <Trash style={{ marginLeft: 6 }} size={20} color="white" />
                حذف آدرس
              </Button>
            </div>
            <Link
              to={`/profile/address/edit/${data?.id}?returnUrl=${
                location.pathname
              }&updateAddress=true${_queryToUrlParams(
                Object.fromEntries(searchParams),
              )}`}
            >
              <Button type={'primary'} ghost={true}>
                <Edit
                  style={{ marginLeft: 6 }}
                  size={20}
                  color={Colors.Primary[3]}
                />
                ویرایش آدرس
              </Button>
            </Link>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 10 }}>
              <Button
                type={'danger'}
                onClick={() => deleteAddress()}
                loading={loading}
              >
                <Trash style={{ marginLeft: 6 }} size={20} color="white" />
                حذف آدرس
              </Button>
            </div>
            <Button type={'primary'} ghost={true} onClick={() => setStep(0)}>
              <Edit
                style={{ marginLeft: 6 }}
                size={20}
                color={Colors.Primary[3]}
              />
              انصراف
            </Button>
          </>
        )}
      </div>
    </Modal>
  )
}

export default AddressActionModal
